module.exports = __webpack_public_path__ + "static/img/qqcode2.fceaea60.jpg";